Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var isLandscape = _ref.isLandscape;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    box = _STYLES$useStyles.box,
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    boxShadows = _STYLES$useStyles.boxShadows,
    fontRegular = _STYLES$useStyles.fontRegular,
    grid = _STYLES$useStyles.grid,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    bp = _STYLES$useStyles.bp,
    COLORS = _STYLES$useStyles.COLORS;
  var _smallBp = isLandscape || bp.is([bp.mobile_normal, bp.mobile_m, bp.mobile_l]);
  var container = Object.assign({}, box, {
    maxWidth: _reactNative.Platform.OS === 'web' ? "calc(".concat(grid.maxBoxWidth, " / 2)") : grid.maxBoxWidth / 2,
    alignItems: 'center',
    position: 'relative',
    flex: 1
  });
  if (_smallBp) {
    container.padding = spacing.xs;
  }
  var container_flat = Object.assign({}, boxShadows.none, {
    borderColor: COLORS.iron,
    borderStyle: 'solid',
    borderWidth: (0, _styles.getREM)(0.0625)
  });
  var container_pointerOver = Object.assign({}, boxShadows.box_pointerOver.all);
  var value = Object.assign({}, fontBold, {
    color: colors.brand,
    fontSize: fontSize.xxl,
    lineHeight: lineHeight.xxl
  });
  if (_smallBp) {
    value.fontSize = fontSize.xl;
    value.lineHeight = fontSize.xxl;
  }
  var label = Object.assign({}, fontSemiBold, {
    color: colors.brand,
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    textAlign: 'center'
  });
  if (_smallBp) {
    label.fontSize = fontSize.normal;
    label.lineHeight = lineHeight.normal;
    label.textAlign = 'left';
  }
  var imageContainer = {
    marginTop: spacing.xs
  };
  if (_smallBp) {
    imageContainer.marginTop = 0;
    imageContainer.maxWidth = '100%';
  }
  var image = {
    width: '100%',
    height: '100%'
  };
  var fakeLink = {
    color: colors.alternative,
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    marginTop: spacing.xs
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l])) {
    fakeLink.display = 'none';
  }
  var linkContainer = {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  var linkText = {
    width: '100%',
    height: '100%',
    borderRadius: box.borderRadius
  };
  var description = Object.assign({}, fontRegular, {
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    textAlign: 'center',
    color: colors.brand,
    marginTop: spacing.xs,
    width: '100%'
  });
  if (_smallBp) {
    description.textAlign = 'left';
  }
  var primaryContentContainer = {
    alignItems: 'center',
    width: '100%'
  };
  if (_smallBp) {
    primaryContentContainer.flexDirection = 'row-reverse';
    primaryContentContainer.gap = spacing.m;
    primaryContentContainer.justifyContent = 'flex-end';
  }
  var primaryContentText = {
    alignItems: 'center'
  };
  if (_smallBp) {
    primaryContentText.alignItems = 'flex-start';
    primaryContentText.flexShrink = 1;
  }
  var primaryContentImage = {
    alignItems: 'center'
  };
  if (_smallBp) {
    primaryContentImage.width = '30%';
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_flat: container_flat,
    container_pointerOver: container_pointerOver,
    value: value,
    label: label,
    imageContainer: imageContainer,
    image: image,
    fakeLink: fakeLink,
    linkContainer: linkContainer,
    linkText: linkText,
    description: description,
    primaryContentContainer: primaryContentContainer,
    primaryContentText: primaryContentText,
    primaryContentImage: primaryContentImage
  });
  return {
    styles: styles
  };
};